import React, { memo, useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';

import styles from './WpCardPkg.module.less';
import WpProductDownloadBtn from './WpProductDownloadBtn';
import { CONTEXT, WP_PAY_RANK_LIST_80 } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import {
  hasClass,
  removeClass,
  addClass,
  getQueryString,
  logNative,
  createAxios,
} from '../../utils/utils';

import transparent from '../../static/transparent.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ cardInfo, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const [isDownloading, setIsDownloading] = useState(false);
  const [rankList, setRankList] = useState({});

  useEffect(() => {
    if (cardInfo.rankInfo && cardInfo.rankInfo.code) {
      getRankInfo(cardInfo.rankInfo.code);
    }
  }, []);

  const getRankInfo = useCallback(async code => {
    const axios = await createAxios('isNeedUser');
    axios
      .get(WP_PAY_RANK_LIST_80, {
        params: {
          limit: 1000,
          skip: 0,
          code: code,
          wallpaperId: '',
        },
      })
      .then(res => {
        if (res && res.data && res.data.status === 0) {
          setRankList(res.data.data);
        }
      });
  }, []);

  const onMouseOver = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.wpimg_img)[0];
    addClass(el, styles.image_mouse_in);
  }, []);

  const onMouseLeave = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.wpimg_img)[0];
    addClass(el, styles.image_mouse_out);
  }, []);

  const onAnimationEnd = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.wpimg_img)[0];
    if (hasClass(el, styles.image_mouse_out)) {
      removeClass(el, styles.image_mouse_in);
      removeClass(el, styles.image_mouse_out);
    }
  }, []);
  const onError = function(e, flag) {
    if (e.currentTarget && e.currentTarget.src) {
      e.currentTarget.src = transparent;
    }
  };

  const handleRank = useCallback(() => {
    dispatch(
      logPostInfo({
        source_p: logInfo.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/wprank?code=${cardInfo.rankInfo && cardInfo.rankInfo.code}&pay=1`);
  }, [logInfoData]);

  let imgSrc = transparent;
  if (
    cardInfo &&
    cardInfo.wallpaperInfo &&
    cardInfo.wallpaperInfo.wallpaperImg &&
    cardInfo.wallpaperInfo.wallpaperImg[0] &&
    cardInfo.wallpaperInfo.wallpaperImg[0].uri
  ) {
    imgSrc = cardInfo.wallpaperInfo.wallpaperImg[0].uri;
  }
  return (
    <>
      <div className={styles.card}>
        <div className={styles.card_wp_bg2} />
        <div className={styles.card_wp_bg1} />
        <div
          className={styles.card_wp}
          onMouseOver={e => onMouseOver(e)}
          onMouseLeave={e => onMouseLeave(e)}
          onAnimationEnd={e => onAnimationEnd(e)}
        >
          <img
            className={styles.wpimg_img}
            src={imgSrc}
            onError={onError}
            onClick={handleRank}
            alt="img"
          />
          <div className={styles.card_wp_header} onClick={handleRank}>
            <span className={styles.opt_wallpaper_info} title="查看壁纸包" />
          </div>
          <div className={styles.card_wp_footer}>
            <WpProductDownloadBtn
              className={styles.btn}
              wallpaper={{ ...rankList, type: 2 }}
              hasDownloading={false}
              setIsDownload={flag => {
                setIsDownloading(flag);
              }}
            >
              {/* {!isDownloading ? (
                <>
                  <span className={`iconfont icon-wp_download ${styles.btn_icon}`} />
                  <span>下载壁纸包</span>
                </>
              ) : (
                <span>下载中</span>
              )} */}
            </WpProductDownloadBtn>
          </div>
        </div>
      </div>
    </>
  );
});
